<template src="@/templates/account/passwordReset.html"></template>
<script>
import LoginModel from "@/models/loginModel";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "PasswordReset",
  props: ["passwordToken"],
  data() {
    return {
      loginModel: new LoginModel(),
      passwordNew: "",
      passwordConfirm: "",
      popUpShow: true,
    };
  },
  mixins: [validationMixin],
  validations: {
    passwordNew: {
      required,
      minLength: minLength(8),
    },
    passwordConfirm: {
      required,
      sameAs: sameAs("passwordNew"),
    },
  },
  methods: {
    gotoLogin() {
      this.$router.push({ name: "login" });
    },
    processResetPassword() {
      this.$v.$touch();

      if (this.$v.$error) {
        return;
      }

      let passValidation = this.validatePasswordNew(true);
      if (passValidation) {
        this.loginModel
          .save({
            url:
              this.$interpretersApiUrl +
              this.loginModel.getRoute("resetPassword"),
            data: {
              newPassword: this.passwordNew,
              token: this.passwordToken,
            },
          })
          .then((res) => {
            console.log(res);
            let response = res.response.data;

            if (!response) {
              let errorMessage = "Network error. " + response.message;
              this.passwordResetError(errorMessage);
              return;
            }

            this.passwordNew = "";
            this.passwordConfirm = "";

            if (response.error) {
              if (response.token == "") {
                this.passwordResetError(
                  "Unable to update password. Link expired."
                );
              } else {
                let errorMessage = "User error. " + response.error;
                this.passwordResetError(errorMessage);
              }
            } else {
              this.$vs.notify({
                title: "Success",
                text: "Password Updated Successfully.",
                time: 4000,
                color: "success",
                position: "top-center",
              });

              this.gotoLogin();
            }
          });
      } else {
        this.$vs.notify({
          title: "Warning!",
          text: passValidation,
          time: 4000,
          color: "warning",
          position: "top-center",
        });
      }
    },
    validatePasswordNew(submit = false, newPassword = this.passwordNew) {
      let errorMessage = "";
      if (newPassword == "") {
        errorMessage = "Fields are required.";
      } else if (newPassword.length < 8) {
        errorMessage = "Your password must be at least 8 characters";
      } else if (
        newPassword.search(/[A-Z]/) < 0 ||
        newPassword.search(/[0-9]/) < 0
      ) {
        errorMessage =
          "Your password must contain at least one uppercase letter & 1 number";
      }

      if (submit == true) {
        if (errorMessage == "") {
          let errorMessageConf = this.validatePasswordConfirm();

          if (errorMessageConf == "") {
            return true;
          } else {
            return errorMessageConf;
          }
        }
      }

      return errorMessage;
    },
    validatePasswordConfirm(
      newPassword = this.passwordNew,
      confirmPassword = this.passwordConfirm
    ) {
      let errorMessage = "";
      if (confirmPassword == "") {
        errorMessage = "Fields are required.";
      } else if (newPassword != confirmPassword) {
        errorMessage = "Password confirmation does not match.";
      }

      return errorMessage;
    },
    passwordResetError(errorMessage = null) {
      if (!errorMessage) {
        errorMessage = "Unable to update password";
      }

      this.$vs.notify({
        title: "Failure",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
  },
};
</script>
